export interface IImageNineSliceRule
{
  image_width: number;
  image_height: number;
  x1: number;
  x2: number;
  y1: number;
  y2: number;
  slice_mode: SliceMode;
  cap_fit?: CapFit;
}

export interface IImageNineSliceJson
{
  [key: string]: IImageNineSliceRule;
}

export enum SliceMode
{
  BOTH = "both",
  HORIZONTAL = "horizontal",
  VERTICAL = "vertical"
}

// Як підбирати розмір кутів, коли елемент менший за вихідний ассет.
export enum CapFit
{
  // Стискати кути, щойно елемент менший за весь ассет — весь малюнок
  // пропорційно зменшується. Потрібно дрібним кнопкам, які малюють широкий
  // ассет (напр. кнопка 211px з "frame_btn" при ассеті 580px).
  IMAGE = "image",
  // Стискати кути лише коли самі кути не влазять. Для панелей, які тягнуться
  // на довільну висоту/ширину і мають зберігати авторський радіус кута.
  CAPS = "caps"
}
